import {HttpClient} from "../../retts/index";
import {loginEndPoint as loginEndpoint, changeUserEndPoint as changeUserEndPoint} from "../util/apiEndpoints";

class PredicareAuthManager {
    login(username, password=null, passwordHash=null) {
        let requestBody = {};
        if(passwordHash!==null){
            requestBody = {
                username: username,
                passwordHash: passwordHash
            };
        }else{
            requestBody = {
                username: username,
                password: password
            };
        }

        const httpClient = new HttpClient();
        return httpClient.post(requestBody, loginEndpoint(), null);
    }
    changeUserToDefaultAppUser() {
        return this.login('rettsplus@gmail.com', 'RETTSPlus123123RETTSPlus')
            .then(user => {
                if (user.jwt !== null && user.jwt !== undefined) {
                    return user;
                } else {
                    return null;
                }
            })
            .catch(err => {
                return err;
            });
    }
}

const predicareAuthManager = new PredicareAuthManager();
export default predicareAuthManager;



// WEBPACK FOOTER //
// ./retts/PredicareAuth/PredicareAuthManager.js